import poolAbi from 'abis/AcornReferralsVault.json'
import BigNumber from 'bignumber.js'
import { REFERRALS_VAULT_ADDRESS } from 'constants/addresses'
import useActiveWeb3React from 'hooks/useActiveWeb3React'
import useRefresh from 'hooks/useRefresh'
import { useCallback, useEffect, useState } from 'react'
import { BIG_ZERO } from 'utils/bigNumber'
import Multicall from 'utils/multicall'
import { isChainAllowed } from 'utils/switchChain'

import { PoolDetails } from '../types'

const useGetPublicPoolData = (): PoolDetails => {
  const { slowRefresh } = useRefresh()
  const { chainId, connector } = useActiveWeb3React()
  const [state, setState] = useState({
    totalPoints: BIG_ZERO,
    holders: 0,
  })

  const chainAllowed = chainId && isChainAllowed(connector, chainId)

  const address = REFERRALS_VAULT_ADDRESS[chainAllowed ? chainId : 137]

  const fetchData = useCallback(async () => {
    const PoolCalls = [
      { address, name: 'totalPoints' },
      { address, name: 'totalHolders' },
    ]

    const [totalPoints, totalHolders] = await Multicall(chainAllowed ? chainId : 137, poolAbi, PoolCalls)

    setState((prev) => ({
      ...prev,
      totalPoints: new BigNumber(totalPoints[0].toString() ?? '0'),
      holders: Number(totalHolders[0]),
    }))
  }, [address, chainAllowed, chainId])

  useEffect(() => {
    fetchData()
  }, [fetchData, slowRefresh])

  return { ...state, fetchData }
}

export default useGetPublicPoolData
